import _extends from "@babel/runtime/helpers/esm/extends";
import { EMPTY_ARRAY } from '@base-ui/utils/empty';
import { MinimalTreeViewStore } from "../MinimalTreeViewStore/index.mjs";
import { TreeViewJSXItemsPlugin } from "../plugins/jsxItems/index.mjs";
import { parametersToStateMapper } from "./SimpleTreeViewStore.utils.mjs";
export class SimpleTreeViewStore extends MinimalTreeViewStore {
  jsxItems = new TreeViewJSXItemsPlugin(this);
  constructor(parameters) {
    super(_extends({}, parameters, {
      items: EMPTY_ARRAY
    }), 'SimpleTreeView', parametersToStateMapper);
  }
  updateStateFromParameters(parameters) {
    super.updateStateFromParameters(_extends({}, parameters, {
      items: EMPTY_ARRAY
    }));
  }
}